import styled from "styled-components";

const StyledLoader = styled.div`    
    z-index: 1000;
`;

export default StyledLoader;